import React from "react";
import { Clock, X, Search, Church, Users } from "lucide-react";
import { resolveMediaUrl } from "@/components/FileUpload";
import { useApp } from "@/context/AppContext";
import { entryKey } from "@/lib/recentSearches";

const ICON = { query: Search, church: Church, group: Users };

const Thumb = ({ e }) => {
  if (e.kind !== "query" && e.img) {
    return <img src={resolveMediaUrl(e.img)} alt="" className={`h-9 w-9 object-cover shrink-0 ${e.kind === "user" ? "rounded-full" : "rounded-lg"}`} />;
  }
  const Icon = ICON[e.kind] || Clock;
  return <span className="h-9 w-9 rounded-full grid place-items-center shrink-0" style={{ background: "var(--yalola-surface-alt)", color: "var(--yalola-text-muted)" }}><Icon size={15} /></span>;
};

// "Récentes" list shown when the search bar is opened with an empty query.
export const RecentSearches = ({ items, onPick, onRemove, onClear, compact = false }) => {
  const { t } = useApp();
  if (!items?.length) return null;
  return (
    <div data-testid="search-recent">
      <div className="flex items-center justify-between px-3 pt-2 pb-1">
        <span className="text-[10px] font-bold uppercase tracking-widest" style={{ color: "var(--yalola-text-muted)" }}>{t("search.recent", "Récentes")}</span>
        <button type="button" onClick={onClear} className="text-xs font-semibold" style={{ color: "var(--yalola-primary)" }} data-testid="search-recent-clear">{t("search.recent_clear", "Effacer")}</button>
      </div>
      {items.map((e) => {
        const k = entryKey(e);
        return (
          <div key={k} className={`flex items-center gap-1 pr-2 ${compact ? "" : "rounded-xl"} hover:bg-[color:var(--yalola-surface-alt)] transition-colors`} data-testid={`search-recent-item-${e.kind}`}>
            <button type="button" onClick={() => onPick(e)} className="flex-1 min-w-0 flex items-center gap-2.5 px-3 py-2 text-left" data-testid={`search-recent-pick-${e.kind}-${e.id || e.q}`}>
              <Thumb e={e} />
              <span className="min-w-0">
                <span className="block text-sm font-semibold truncate">{e.kind === "query" ? e.q : e.name}</span>
                {e.sub && <span className="block text-[11px] truncate" style={{ color: "var(--yalola-text-muted)" }}>{e.sub}</span>}
              </span>
            </button>
            <button type="button" onClick={() => onRemove(k)} className="h-8 w-8 grid place-items-center rounded-full shrink-0 hover:bg-black/5" style={{ color: "var(--yalola-text-muted)" }} aria-label={t("common.delete", "Supprimer")} data-testid="search-recent-remove"><X size={14} /></button>
          </div>
        );
      })}
    </div>
  );
};
